import { BillingListComponent } from './billing-list/billing-list.component';
export var billingRoutes = [
    {
        path: 'billing',
        component: BillingListComponent
    }
];
var BillingRoutingModule = (function () {
    function BillingRoutingModule() {
    }
    return BillingRoutingModule;
}());
export { BillingRoutingModule };



// WEBPACK FOOTER //
// /opt/app/src/app/features/billing/billing-routing.module.ts.pre-build-optimizer.js